module.exports = __webpack_public_path__ + "media/Tarjeta 14.952fa815.mp4";